
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"29.583","cy":"30.417","r":"28.738","fill":"#fff","stroke":"#232D37","stroke-width":"1.69"}}),_c('path',{attrs:{"d":"M36.383 20.1a.84.84 0 00-.837-.842.84.84 0 00-.838.842v3.203a.84.84 0 00.838.842.84.84 0 00.837-.842V20.1zM36.583 26.787a1.04 1.04 0 01-1.037 1.043 1.04 1.04 0 01-1.038-1.043 1.04 1.04 0 011.038-1.043 1.04 1.04 0 011.037 1.043z","fill":"#202D38"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.591 23.493c0-4.415 3.561-7.993 7.955-7.993 4.393 0 7.954 3.578 7.954 7.993 0 4.414-3.561 7.992-7.954 7.992s-7.955-3.578-7.955-7.992zm7.955-6.31c-3.468 0-6.28 2.825-6.28 6.31 0 3.484 2.812 6.31 6.28 6.31 3.468 0 6.279-2.826 6.279-6.31 0-3.485-2.812-6.31-6.28-6.31z","fill":"#202D38"}}),_c('path',{attrs:{"d":"M19.013 20.942a.84.84 0 00-.838.841v18.192a.84.84 0 00.838.842h18.104a.84.84 0 00.838-.842v-6.492a.84.84 0 01.838-.842.84.84 0 01.837.842v6.492a2.519 2.519 0 01-2.513 2.525H19.013a2.519 2.519 0 01-2.513-2.525V21.783a2.519 2.519 0 012.513-2.525h6.426a.84.84 0 01.838.842.84.84 0 01-.838.842h-6.426z","fill":"#202D38"}}),_c('path',{attrs:{"d":"M20.796 24.346a.84.84 0 00-.837.842.84.84 0 00.837.842h4.454a.84.84 0 00.838-.842.84.84 0 00-.838-.842h-4.454zM19.959 36.589a.84.84 0 01.837-.842h14.572a.84.84 0 01.837.842.84.84 0 01-.837.841H20.796a.84.84 0 01-.837-.841zM20.796 30.047a.84.84 0 00-.837.841.84.84 0 00.837.842h7.13a.84.84 0 00.839-.842.84.84 0 00-.838-.841h-7.13z","fill":"#202D38"}})])
          )
        }
      }
    